export const applicationBuild = { major: 3, minor: 2, patch: 763, id: 73680, version: "3.2.763-b73680" };
